import AcceptanceLetter_HarryPotter_01_Cupboard from "./hp-acceptance-letters/hp-ac-letter-harry-potter-01-the-cupboard-under-the-stairs";
import AcceptanceLetter_HarryPotter_02_Bedroom from "./hp-acceptance-letters/hp-ac-letter-harry-potter-02-the-smallest-bedroom";
import AcceptanceLetter_HarryPotter_03_Hotel from "./hp-acceptance-letters/hp-ac-letter-harry-potter-03-railview-hotel";
import AcceptanceLetter_HarryPotter_04_Hut from "./hp-acceptance-letters/hp-ac-letter-harry-potter-04-hut-on-the-rock";
import AcceptanceLetter_JanHamernik from "./hp-acceptance-letters/hp-ac-jan-hamernik";
import AcceptanceLetter_RonaldWeasley_Burrow from "./hp-acceptance-letters/hp-ac-ronald-weasley-the-burrow";
import AdvancedPotionMakingEditionII from "./hp-advanced-potion-making/edition-II/";
import AdvancedPotionMakingEditionIIPrince from "./hp-advanced-potion-making/edition-II-prince's-copy";
import AdvancedPotionMakingEditionIV from "./hp-advanced-potion-making/edition-IV";
import DailyProphet_HP1_BreakInAtGringotts from "./hp-daily-prophets/hp-daily-prophet-hp1-break-in-at-gringotts";
import DailyProphet_HP2_FlyingFordAngliaMystifiesMuggles from "./hp-daily-prophets/hp-daily-prophet-hp2-flying-ford-anglia-mystifies-muggles";
import DailyProphet_HP3_EscapeFromAzkaban from "./hp-daily-prophets/hp-daily-prophet-hp3-escape-from-azkaban";
import DailyProphet_HP3_GrandPrizeWinnerVisitsEgypt from "./hp-daily-prophets/hp-daily-prophet-hp3-grand-prize-winner-visits-egypt";
import DailyProphet_HP3_SiriusBlackSighted from "./hp-daily-prophets/hp-daily-prophet-hp3-sirius-black-sighted";
import DailyProphet_HP4_BulgariaVsIreland from "./hp-daily-prophets/hp-daily-prophet-hp4-bulgaria-vs-ireland";
import DailyProphet_HP4_HarryPottersSecretHeartache from "./hp-daily-prophets/hp-daily-prophet-hp4-harry-potters-secret-heartache";
import DailyProphet_HP4_SpecialEditionTriwizardTournament from "./hp-daily-prophets/hp-daily-prophet-hp4-special-edition-triwizard-tournament";
import DailyProphet_HP4_TerrorAtTheQuidditchWorldCup from "./hp-daily-prophets/hp-daily-prophet-hp4-terror-at-the-quidditch-world-cup";
import DailyProphet_HP5_DumbledoreDaftOrDangerous from "./hp-daily-prophets/hp-daily-prophet-hp5-dumbledore-daft-or-dangerous";
import DailyProphet_HP5_HeWhoMustNotBeNamedReturns from "./hp-daily-prophets/hp-daily-prophet-hp5-he-who-must-not-be-named-returns";
import DailyProphet_HP5_MassBreakoutFromAzkaban from "./hp-daily-prophets/hp-daily-prophet-hp5-mass-breakout-from-azkaban";
import DailyProphet_HP5_MassBreakoutFromAzkaban_Alternative from "./hp-daily-prophets/hp-daily-prophet-hp5-mass-breakout-from-azkaban-alternative";
import DailyProphet_HP5_TheBoyWhoLies from "./hp-daily-prophets/hp-daily-prophet-hp5-the-boy-who-lies";
import DailyProphet_HP5_TheBoyWhoLies_Alternative from "./hp-daily-prophets/hp-daily-prophet-hp5-the-boy-who-lies-alternative";
import DailyProphet_HP6_AmeliaBonesFoundMurderedAtHerHome from "./hp-daily-prophets/hp-daily-prophet-hp6-amelia-bones-found-murdered-at-her-home";
import DailyProphet_HP6_BridgeCollapseDeathTollRises from "./hp-daily-prophets/hp-daily-prophet-hp6-bridge-collapse-death-toll-rises";
import DailyProphet_HP6_BridgeCollapseDeathTollRises_Alternative from "./hp-daily-prophets/hp-daily-prophet-hp6-bridge-collapse-death-toll-rises-alternative";
import DailyProphet_HP6_DeathEaterTerrorContinues from "./hp-daily-prophets/hp-daily-prophet-hp6-death-eater-terror-continues";
import DailyProphet_HP6_FamilySavagedInLatestDeathEaterAttack from "./hp-daily-prophets/hp-daily-prophet-hp6-family-savaged-in-latest-death-eater-attack";
import DailyProphet_HP7_DarkMarkSparksPanic from "./hp-daily-prophets/hp-daily-prophet-hp7-dark-mark-sparks-panic";
import DailyProphet_HP7_DumbledoresDarkSecretsRevealed from "./hp-daily-prophets/hp-daily-prophet-hp7-dumbledores-dark-secrets-revealed";
import DailyProphet_HP7_HarryPotterUndesirableNo1 from "./hp-daily-prophets/hp-daily-prophet-hp7-harry-potter-undesirable-no-1";
import DailyProphet_HP7_NewHeadmasterForHogwarts from "./hp-daily-prophets/hp-daily-prophet-hp7-new-headmaster-for-hogwarts";
import DumbledoresLetterToGringotts from "./hp-dumbledores-letter-to-gringotts";
import ElderWand from "./hp-elder-wand";
import HarrysWand from "./hp-harrys-wand";
import MaraudersMap from "./hp-marauders-map";
import Quibbler_HP5_HowFarWillFudgeGo from "./hp-quibbler/hp-quibbler-hp5-how-far-will-fudge-go";
import Quibbler_HP6_Spectrespecs from "./hp-quibbler/hp-quibbler-hp6-spectrespecs";
import Quibbler_HP7_HarryInHiding from "./hp-quibbler/hp-quibbler-hp7-harry-in-hiding";
import Quibbler_HP7_IssueNo1 from "./hp-quibbler/hp-quibbler-hp7-issue-no1";
import Quibbler_HP7_MuggleMurdersRise from "./hp-quibbler/hp-quibbler-hp7-muggle-murders-rise";
import Quibbler_HP7_UndesirableNo1 from "./hp-quibbler/hp-quibbler-hp7-undesirable-no1";
import Quibbler_HP7_YouKnowWhoClaimsAnotherVictim from "./hp-quibbler/hp-quibbler-hp7-you-know-who-claims";
import TalesOfBeedleTheBard from "./hp-tales-of-beedle-the-bard";
import VoldemortsWand from "./hp-voldemorts-wand";

// WIP REPLICAS WILL BE FILTERED OUT OF THE LIST OF REPLICAS
// AND WILL BE ACCESSIBLE THROUGH /replicas-wip URL
const replicas = [
  MaraudersMap,
  TalesOfBeedleTheBard,
  AdvancedPotionMakingEditionIIPrince,
  AdvancedPotionMakingEditionII,
  AdvancedPotionMakingEditionIV,
  DailyProphet_HP7_NewHeadmasterForHogwarts,
  DailyProphet_HP7_HarryPotterUndesirableNo1,
  DailyProphet_HP7_DumbledoresDarkSecretsRevealed,
  DailyProphet_HP7_DarkMarkSparksPanic,
  DailyProphet_HP6_AmeliaBonesFoundMurderedAtHerHome,
  DailyProphet_HP6_FamilySavagedInLatestDeathEaterAttack,
  DailyProphet_HP6_DeathEaterTerrorContinues,
  DailyProphet_HP6_BridgeCollapseDeathTollRises,
  DailyProphet_HP6_BridgeCollapseDeathTollRises_Alternative,
  DailyProphet_HP5_HeWhoMustNotBeNamedReturns,
  DailyProphet_HP5_MassBreakoutFromAzkaban,
  DailyProphet_HP5_MassBreakoutFromAzkaban_Alternative,
  DailyProphet_HP5_DumbledoreDaftOrDangerous,
  DailyProphet_HP5_TheBoyWhoLies,
  DailyProphet_HP5_TheBoyWhoLies_Alternative,
  DailyProphet_HP4_HarryPottersSecretHeartache,
  DailyProphet_HP4_SpecialEditionTriwizardTournament,
  DailyProphet_HP4_TerrorAtTheQuidditchWorldCup,
  DailyProphet_HP4_BulgariaVsIreland,
  DailyProphet_HP3_SiriusBlackSighted,
  DailyProphet_HP3_GrandPrizeWinnerVisitsEgypt,
  DailyProphet_HP3_EscapeFromAzkaban,
  DailyProphet_HP2_FlyingFordAngliaMystifiesMuggles,
  DailyProphet_HP1_BreakInAtGringotts,
  Quibbler_HP6_Spectrespecs,
  Quibbler_HP5_HowFarWillFudgeGo,
  Quibbler_HP7_HarryInHiding,
  Quibbler_HP7_MuggleMurdersRise,
  Quibbler_HP7_UndesirableNo1,
  Quibbler_HP7_YouKnowWhoClaimsAnotherVictim,
  Quibbler_HP7_IssueNo1,
  AcceptanceLetter_HarryPotter_01_Cupboard,
  AcceptanceLetter_HarryPotter_02_Bedroom,
  AcceptanceLetter_HarryPotter_03_Hotel,
  AcceptanceLetter_HarryPotter_04_Hut,
  AcceptanceLetter_RonaldWeasley_Burrow,
  AcceptanceLetter_JanHamernik,
  DumbledoresLetterToGringotts,
  HarrysWand,
  ElderWand,
  VoldemortsWand,
];

export default replicas;
